import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Overlay from "containers/general/overlay"
import MobileMenuButton from "components/MobileMenuButton"
import { Route, Link, Redirect, Switch } from "react-router-dom"
import LoadingOverlay from "containers/general/loadingOverlay"
import { compose } from "redux"
import { getPayload, setActiveProperties, setViewAs, loadingStatus } from "../actions"
import classNames from "classnames"
//import ErrorBoundary from "components/ErrorBoundary"
import clone from "clone"
import _ from "lodash"
import settings from "settings"
import moment from "moment"
import axios from "axios"
import { io } from "socket.io-client"
import Switched from "react-switch"
import DriveModeButton from "components/DriveModeButton"
import DriveMode from "containers/mapping/DriveMode"

import "chartjs-plugin-datalabels"
Chart.defaults.global.plugins.datalabels.color = "#222"
Chart.defaults.global.plugins.datalabels.display = function (ctx) {
	//console.log(ctx)
	return ctx.dataset.data[ctx.dataIndex] !== 0
}

import "chartjs-plugin-zoom"
import "react-responsive-modal/styles.css"
import TablePrinter from "containers/TablePrinter"
//const Dashboard = React.lazy(() => import("./reports/dashboard"))
import Dashboard from "./reports/dashboard"
import Executive from "./reports/executive"
import Builder from "./reports/builder"
import Sales from "./reports/sales"
import RealtorReport from "./reports/realtorReport"
const WebLeads = React.lazy(() => import("./reports/webLeads"))
import Cancels from "./reports/cancels"
import Traffic from "./reports/traffic"
import ZipCode from "./reports/zipCode"
import BuilderPortalActivity from "./reports/activityBuilderPortal"
import RejectionLog from "./reports/activityRejectionLog"
import ExceptionsLog from "./reports/activityExceptions"
import BrokerageExceptions from "./reports/brokerageExceptions"
import EmailLog from "./reports/emailLog"
import ActivityDetail from "./reports/activityDetail"
import Account from "./general/account"
import ClosingsOverview from "./reports/closings"
import ARCReport from "./reports/arcReport"
import EditSale from "./entry/editSale"
import SalesVariance from "./reports/salesVariance"
import EditCancel from "./entry/editCancel"
import helpers from "helpers/helpers"
import HeatTraffic from "./reports/heatTraffic"
const LotStatus = React.lazy(() => import("./reports/lotStatus"))
const DataExporter = React.lazy(() => import("./admin/dataExporter"))
const Messaging = React.lazy(() => import("./admin/messaging"))
const LotReservations = React.lazy(() => import("./reports/lotReservations"))
const CompetitionOverview = React.lazy(() => import("./competition/overview"))
const Transfers = React.lazy(() => import("./reports/transfers"))
const ExecutiveAnalysis = React.lazy(() => import("./reports/executiveAnalysis"))
const BuilderPortalCalendar = React.lazy(() => import("./admin/builderPortalCalendar"))
const InfoCenterUsers = React.lazy(() => import("./admin/infoCenterUsers"))
const TitleCompanies = React.lazy(() => import("./admin/titleCompanies"))
const Schools = React.lazy(() => import("./admin/schools"))
const BuyerAnalysis = React.lazy(() => import("./reports/buyerAnalysis"))
const Revenue = React.lazy(() => import("./reports/revenue"))
const CommunityStatsReport = React.lazy(() => import("./reports/communityStats"))
const Employees = React.lazy(() => import("./admin/employees"))
const Commercial = React.lazy(() => import("./admin/commercial"))
const TrafficYoY = React.lazy(() => import("./reports/trafficYoY"))
import MarketingModels from "./reports/marketingModels"
import HomeSalesTrend from "containers/reports/homeSalesTrend"
import DemographicsYoY from "./reports/demoYoY"
import Demographics from "./reports/demographics"
const MarketingGeographics = React.lazy(() => import("./reports/marketingGeographics"))
const ProspectAnalytics = React.lazy(() => import("./reports/prospectAnalytics"))
import SalesYTD from "./reports/salesYTD"
import HeatSales from "./reports/heatSales"
import HeatClosings from "./reports/heatClosings"
const Playground = React.lazy(() => import("./reports/playground"))
const LotFees = React.lazy(() => import("./reports/lotFees"))
const Resales = React.lazy(() => import("./reports/Resales"))
import MarketingFloorplans from "./reports/marketingFloorplans"
import Averages from "./reports/averages"
import BuilderList from "./reports/builderList"
import CommunityStats from "./reports/salespeopleCommunitySales"
import InventoryLotSize from "./reports/inventoryLotSize"
import LotSalesStatus from "./reports/lotSalesStatus"
import InventorySection from "./reports/inventorySection"
import BuilderInventorySupply from "./reports/builderInventorySupply"
import HomeConstructionStatus from "./reports/homeConstructionStatus"
import BuilderPerformance from "./reports/builderPerformance"
import Takedown from "./reports/takedown"
import DeveloperLotInventory from "./reports/financial"
import BadData from "./reports/badData"
import PriceParticipation from "./reports/participateFee"
import SalesAnalysis from "./reports/salesAnalysis"
import MUD from "./reports/mud"
import ClosingAverages from "./reports/closingAverages"
import Starts from "./reports/inventoryStarts"
const ExecutiveSnapshot = React.lazy(() => import("./reports/executiveSnapshot"))
const MarketingCampaigns = React.lazy(() => import("./admin/marketingCampaigns"))
import Vacants from "./reports/inventoryVacants"
import Completes from "./reports/inventoryCompletes"
import BuilderSalesSummary from "./reports/builderSalesSummary"
import CommunityPerformance from "./reports/communityPerformance"
import LotManagement from "./admin/lot-management"
const AreaFeatures = React.lazy(() => import("./admin/areaFeatures"))
const WebAdmin = React.lazy(() => import("./admin/webAdmin"))
const AdminCommunityStats = React.lazy(() => import("./admin/communityStats"))
import InfoCenter from "./admin/infoCenter"
import UserManagement from "./admin/user-management"
import LandInventory from "./admin/landInventory"
const LotMap = React.lazy(() => import("./reports/lotMap"))
const ConstructionMap = React.lazy(() => import("./reports/constructionMap"))
const LandInventoryMap = React.lazy(() => import("./reports/landInventoryMap"))
const BuilderDeveloperInternal = React.lazy(() => import("./reports/builderDeveloperInternal"))
const InventorySnapshot = React.lazy(() => import("./reports/inventorySnapshot"))
import BuyerDetails from "/containers/reports/buyerDetails"
import Prospects from "/containers/reports/prospects"
import CommunityManagement from "./admin/communities"
import EditCommunity from "./admin/community"
import AddCommunity from "./admin/addCommunity"
import NeighborhoodManagement from "./admin/neighborhoods"
import EditNeighborhood from "./admin/neighborhood"
import AddNeighborhood from "./admin/addNeighborhood"
import BuilderManagement from "./admin/builders"
import WeeklySummary from "./admin/weeklySummary"
import WeeklyReport from "./reports/weekly"
const SectionPerformance = React.lazy(() => import("./reports/sectionPerformance"))
const NetSales = React.lazy(() => import("./reports/netSales"))
import EditBuilder from "./admin/builder"
import AddBuilder from "./admin/addBuilder"
import SubdivisionManagement from "./admin/subdivisions"
import EditSubdivision from "./admin/subdivision"
import AddSubdivision from "./admin/addSubdivision"
import RealtorBrokerages from "./admin/realtorBrokerages"
import SectionManagement from "./admin/sections"
import EditSection from "./admin/section"
import AddSection from "./admin/addSection"
import RealtorDetail from "./reports/realtorDetail"
import QuarterlyLotSales from "./reports/quarterlyLotSales"
import RealtorBrokerageDetail from "./reports/realtorBrokerageDetail"
import LotTypeManagement from "./admin/lotTypes"
import EditLotType from "./admin/lotType"
import AddLotType from "./admin/addLotType"
import ThankYou from "containers/general/thankyou"
import DocumentManagement from "containers/admin/documents"
import ArcManagement from "containers/admin/arcManagement"
import ISDManagement from "./admin/isds"
import BuilderFeeds from "./admin/builderFeeds"
import LotImport from "./admin/lotImport"
import MassLotUpdate from "./admin/massLotUpdate"
import EditISD from "./admin/isd"
import AddISD from "./admin/addISD"
import LIDManagement from "containers/admin/lids"
import MUDManagement from "containers/admin/muds"
import AddLID from "./admin/addLID"
import AddMUD from "./admin/addMUD"
import ManageLotSalesStatus from "./admin/manageLotSalesStatus"
import EditLID from "./admin/lid"
import EditMUD from "./admin/mud"
import FloorplanManagement from "containers/admin/floorplans"
import AddFloorplan from "./admin/addFloorplan"
import EditFloorplan from "./admin/floorplan"
import Rolling5 from "./reports/rolling5Year"
import Segmentation from "./reports/segmentation"
import ReactSelect from "components/ReactSelect"
import PropertySelect from "components/PropertySelect"
import currentUser from "helpers/currentUser"
import YearOverYear from "containers/reports/yearOverYear"
import Analytics from "containers/reports/analytics"
import SalespersonPerformance from "containers/reports/salespersonPerformance"
import Projections from "containers/reports/projections"
import WeeklyStats from "containers/reports/weeklyStats"
import SpecsAveragePricing from "containers/reports/specsAveragePricing"
import Finder from "containers/general/Finder"
const ARCSubmitMasterDev = React.lazy(() => import("containers/admin/arcSubmitMasterDev"))
const ContractClosingComparison = React.lazy(() => import("containers/reports/contractClosingComparison"))
const LotContract = React.lazy(() => import("containers/admin/lotContract"))
const LotContracts = React.lazy(() => import("containers/admin/lotContracts"))
const ViewLotContractInstruction = React.lazy(() => import("containers/admin/viewLotContractInstruction"))
const LotContractInstructions = React.lazy(() => import("containers/admin/lotContractInstructions"))
const LotContractInstruction = React.lazy(() => import("containers/admin/lotContractInstruction"))
const ChatInterface = React.lazy(() => import("containers/ChatInterface"))
//? Custom modules
const CustomHOASubsection = React.lazy(() => import("containers/custom/Caldwell-HOASubsection"))

let socketURL = ""
if (settings.ep.includes("http://")) socketURL = `ws://${settings.ep.replace("http://", "")}`
else if (settings.ep.includes("https://")) socketURL = `wss://${settings.ep.replace("https://", "")}`
const user = currentUser()
let socket
if (user?.super) {
	socket = io(socketURL)
}

class App extends Component {
	constructor(props) {
		super(props)
		this.state = {
			navBuilt: false, // only build the nav once
			navOpen: false,
			invalid: false, // making sure salespeople can't login to manager section
			nav: [],
			sidebarOpen: true,
			viewAs: false,
			monitor: [],
			monitorOpen: false,
			parentOpen: false, // When clicking on a subnav, this keeps track of the parent that is active
			shake: false,
			dark: false,
			isDriveMode: false,
			// This is due to the dynamic variable names below.  Have to reference the import.  May be a better way to do this, but it's crunch time.
			components: {
				Dashboard,
				Executive,
				Builder,
				Sales,
				RealtorReport,
				Cancels,
				Traffic,
				ZipCode,
				AreaFeatures,
				BuilderPortalActivity,
				RejectionLog,
				ExceptionsLog,
				BrokerageExceptions,
				ActivityDetail,
				Account,
				ClosingsOverview,
				EditSale,
				SalesVariance,
				EditCancel,
				HeatTraffic,
				LotStatus,
				DemographicsYoY,
				Demographics,
				RealtorDetail,
				RealtorBrokerageDetail,
				ExecutiveSnapshot,
				MarketingGeographics,
				ProspectAnalytics,
				InventorySnapshot,
				BuyerDetails,
				BuilderFeeds,
				SalesYTD,
				HeatSales,
				HeatClosings,
				Playground,
				Averages: Averages,
				BuilderList,
				MarketingModels,
				LotReservations,
				CommunityStats,
				CommunityManagement,
				EditCommunity,
				AddCommunity,
				NeighborhoodManagement,
				DataExporter,
				EditNeighborhood,
				AddNeighborhood,
				BuilderManagement,
				ManageLotSalesStatus,
				LotSalesStatus,
				EditBuilder,
				AddBuilder,
				LotTypeManagement,
				BuilderDeveloperInternal,
				EditLotType,
				AddLotType,
				SubdivisionManagement,
				EditSubdivision,
				AddSubdivision,
				SectionManagement,
				EditSection,
				AddSection,
				InventoryLotSize,
				InventorySection,
				LotManagement,
				UserManagement,
				ThankYou,
				DocumentManagement,
				EmailLog,
				ISDManagement,
				AddISD,
				AddMUD,
				EditISD,
				LIDManagement,
				MUDManagement,
				EditLID,
				EditMUD,
				AddLID,
				FloorplanManagement,
				EditFloorplan,
				AddFloorplan,
				Rolling5,
				Segmentation,
				YearOverYear,
				BuilderInventorySupply,
				HomeConstructionStatus,
				BuilderPerformance,
				HomeSalesTrend,
				ClosingAverages,
				BuilderSalesSummary,
				QuarterlyLotSales,
				Starts,
				Completes,
				Takedown,
				BadData,
				PriceParticipation,
				SalesAnalysis,
				MUD,
				WeeklySummary,
				WeeklyReport,
				InfoCenter,
				Prospects,
				LotImport,
				MarketingCampaigns,
				Analytics,
				MassLotUpdate,
				SalespersonPerformance,
				SpecsAveragePricing,
				RealtorBrokerages,
				Projections,
				DeveloperLotInventory,
				MarketingFloorplans,
				WebAdmin,
				ArcManagement,
				LandInventory,
				LandInventoryMap,
				WeeklyStats,
				ARCSubmitMasterDev,
				ContractClosingComparison,
				CommunityPerformance,
				SectionPerformance,
				WebLeads,
				Vacants,
				LotMap,
				Transfers,
				LotFees,
				ExecutiveAnalysis,
				CompetitionOverview,
				BuilderPortalCalendar,
				InfoCenterUsers,
				BuyerAnalysis,
				Revenue,
				NetSales,
				Schools,
				Employees,
				Commercial,
				AdminCommunityStats,
				LotContract,
				LotContracts,
				ViewLotContractInstruction,
				LotContractInstructions,
				LotContractInstruction,
				TitleCompanies,
				Messaging,
				ConstructionMap,
				CommunityStatsReport,
				TrafficYoY,
				CustomHOASubsection,
				ARCReport,
				Resales
			},
		}
	}

	componentDidMount() {
		// Check that this is a manager and not a salesperson
		var jwtDecode = require("jwt-decode")
		let user = localStorage.getItem("user")
		let processedUser = currentUser()
		let activeProperties = localStorage.getItem("activeProperties")
		user = jwtDecode(user)
		//socket.emit('userConnection', user.id)
		if (activeProperties) {
			this.props.setActiveProperties(JSON.parse(activeProperties))
		}
		if (user.aud !== 100 || user.status == 403) {
			localStorage.removeItem("user")
			this.setState({ invalid: true })
			return
		}
		// This is in place if you're viewing as a salesperson, then exit the window, then come back, the nav would be blank and force users to logout and back in.  If you're mounting this component then viewAs shouldn't be set...I think.
		localStorage.removeItem("viewAs")
		if (processedUser?.super && socket) {
			socket.on("throw", (v) => {
				let monitor = _.clone(this.state.monitor)
				// Add the new socket event in the same data format
				monitor.push({
					user: v.user,
					property: v.property,
					excerpt: v.message || v, // handle both object and string formats
					addedDate: moment().unix(),
				})
				this.setState({ monitor, shake: true })
				setTimeout(() => {
					this.setState({ shake: false })
				}, 1000)
			})
		}
		//? dark mode
		let dark = localStorage.getItem("darkMode")
		if (dark === "true") {
			// dark mode
			document.querySelector("html").classList.add("dark")
			document.querySelector("body").classList.add("dark")
			this.setState({ dark: true })
		} else {
			document.querySelector("html").classList.remove("dark")
			document.querySelector("body").classList.remove("dark")
		}
		//? end dark mode
		this.props.getPayload()
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			localStorage.setItem("currentPath", this.props.location.pathname)
		}
		if (prevProps.payload.modules !== this.props.payload.modules && this.props.payload.modules.length > 0) {
			let nav = clone(this.props.payload.modules)
			let ret = {}
			// Build the nav
			for (let v of nav) {
				if (v.is_parent) {
					v.subNav = []
					ret[v.id] = v
				}
			} // Now add subNav to parents
			for (let v of nav) {
				if (!v.is_parent) {
					ret[v.parent].subNav.push(v)
				}
			}
			ret = _.orderBy(ret, "order")
			this.setState({
				nav: ret,
				navBuilt: true,
			})
		}
		// On init of payload, pull the recentActivity which is set to 50 from the server and put them into the monitor here.
		try {
			if (
				prevProps.payloadStatus !== this.props.payloadStatus &&
				this.state.monitor.length === 0 &&
				this.props.payload?.exec?.recentActivity &&
				this.props.payload?.exec?.recentActivity.length > 0
			) {
				let set = this.props.payload.exec.recentActivity
				set = _.orderBy(set, "addedDate", "asc")
				// Store the raw data in state instead of React elements
				this.setState({ monitor: set })
			}
		} catch (e) {
			console.log(e)
		}
	}

	componentWillUnmount() {
		// Clean up socket listener
		if (socket) {
			socket.off("throw")
		}
	}

	renderNav() {
		var pathArray = window.location.pathname.split("/")
		let f = _.map(this.state.nav, (r, i) => {
			let childHere = false
			if (r.subNav && r.subNav.length > 0) {
				// Method for if this has a subnav
				var subs = []
				//Parent active puts 'active' on the UL if we're on a subpage

				_.forEach(r.subNav, (row, index) => {
					var path = row.path.split("/")
					var here = path[1] == pathArray[1] && path[2] == pathArray[2] ? true : false
					if (here) {
						childHere = true
					}
					var subClasses = classNames("body__subNavItem", {
						here: here,
					})

					subs.push(
						<li
							key={"sub" + index}
							className={subClasses}
							onClick={(e) => {
								e.stopPropagation()
								this.setState({ parentOpen: i })
								this.toggleMobileMenu(row)
							}}>
							<Link to={row.path} />
							<span>{row.name}</span>
						</li>
					)
				})
				var subListClasses = classNames("body__subNav")
				var sub = <ul className={subListClasses}>{subs}</ul>
			}
			// if path is truthy, else no path
			if (r.path) {
				var link = <Link to={r.path} />
				var path = r.path.split("/")
				var here = path[1] == pathArray[1] ? true : false
			}
			var classes = classNames("body__navItem", {
				here: here,
				active: r.active,
				childHere: childHere,
				"body__navItem--hasKids": !r.path,
			})
			return (
				<li
					key={i}
					className={classes}
					onClick={() => {
						this.toggleMobileMenu(r)
						this.toggleSubMenu(r, i)
						if (this.state.parentOpen === i) {
							this.setState({ parentOpen: false })
						} else {
							this.setState({ parentOpen: i })
						}
					}}>
					{link}
					<div className="body__navTitle">
						<i className={`fas ${r.icon} fa-2x`} />
						<span>{r.name}</span>
					</div>
					{sub}
				</li>
			)
		})
		return f
		///return ret
	}

	toggleSubMenu = (r, i) => {
		var c = clone(this.state.nav)
		_.forEach(c, (v, k) => {
			if (k == i) {
				return
			}
			c[k].active = false
		})
		c[i].active = !c[i].active

		if (this.state.parentOpen === i) {
			//c[i].active = true
		}

		this.setState({ nav: c })
	}

	toggleMobileMenu = (r) => {
		if (r.path === false || !r.path) {
			return
		}
		this.setState({
			navOpen: !this.state.navOpen,
		})
	}

	toggleDriveMode = () => {
		this.setState({ isDriveMode: !this.state.isDriveMode })
	}

	exitDriveMode = () => {
		this.setState({ isDriveMode: false })
	}

	changeUser = (v) => {
		this.props.loadingStatus(true)
		var userToken = localStorage.getItem("user")
		axios
			.post(
				settings.ep + "/generateViewAsToken",
				{ id: v, activeProperties: this.props.activeProperties },
				{
					headers: { Authorization: `Bearer ${userToken}` },
				}
			)
			.then((response) => {
				localStorage.setItem("viewAs", response.data.token)
				// Check what the person they want to view as is.
				let find = _.find(this.props.payload.users, { id: v })
				let viewAsID = find ? find.group : null
				this.props.setViewAs(v)
				this.setState({ viewAs: true, viewAsID })
				this.props.loadingStatus(false)
			})
			.catch((error) => {
				// need error handling
				this.props.loadingStatus(false)
			})
	}

	changeProperties = (v, controlHeld) => {
		if (!v) {
			v = []
		}
		let f = []
		for (let r of v) {
			f.push(r)
		}
		if (f.length == 0) {
			localStorage.removeItem("activeProperties")
		} else {
			localStorage.setItem("activeProperties", JSON.stringify(f))
		}
		this.props.setActiveProperties(f)
		// On weekly report, on changing properties, this would double-getting payload.  Weekly report internal alraedy gets payload
		let path = window.location.pathname
		if (path === "/weeklyReport") return
		if (!controlHeld) this.props.getPayload()
	}

	listProperties = (v) => {
		let user = currentUser()
		let arr = []
		if (
			this.props.payload.public.properties.length > 0 &&
			user.activeProperties &&
			typeof user.activeProperties == "object" &&
			user.activeProperties.length > 0
		) {
			// The trackers are to keep track of which metro and metro sub groups this user has access to.
			let individuals = []
			let metro = []
			let metroTracker = [] // the metro areas this person has access to via their property assignemtns
			let metro_subTracker = [] // and the subs they have access to ^
			let countyTracker = []
			_.forEach(this.props.payload.public.properties, (v) => {
				if (user.activeProperties.includes(v.id)) {
					individuals.push({
						value: v.id,
						label: v.name,
						metroGroup: v.metro_group,
						metroSubGroup: v.metro_sub_group,
						countyGroup: v.county,
					})
					metroTracker.push(v.metro_group)
					metro_subTracker.push(v.metro_sub_group)
					if (v.county) countyTracker.push(v.county)
				}
			})
			metroTracker = _.compact(_.uniq(metroTracker))
			metro_subTracker = _.compact(_.uniq(metro_subTracker))
			countyTracker = _.compact(_.uniq(countyTracker))

			individuals = _.sortBy(individuals, "label")

			arr.push({
				label: "Individual Properties",
				options: individuals,
			})

			// Add county groups
			/* if (Object.keys(counties).length > 0) {
				let countyGroups = []
				_.forEach(counties, (properties, countyName) => {
					countyGroups.push({
						label: countyName,
						options: _.sortBy(properties, "label"),
					})
				})
				arr.push({
					label: "Counties",
					options: _.sortBy(countyGroups, "label"),
					isCounty: true,
				})
			} */
			// Now add in metro groups
			_.forEach(this.props.payload.public.metro, (v) => {
				if (metroTracker.includes(v.id) && v.show == 1) {
					metro.push({
						value: `Metro-` + v.id,
						label: v.name,
						group: v.id,
						metro: true,
					})
				}
			})
			if (metro.length > 0) {
				arr.push({
					label: "Metro Areas",
					options: metro,
					isMetro: true,
				})
			}

			// Now add in metro sub groups
			let metro_sub = []
			_.forEach(this.props.payload.public.metroSub, (v) => {
				if (metro_subTracker.includes(v.id) && v.show == 1) {
					metro_sub.push({
						value: `MetroSub` + v.id,
						label: v.name,
						group: v.id,
						metroSub: true,
					})
				}
			})
			if (metro_sub.length > 0) {
				arr.push({
					label: "Metro Sub Areas",
					options: metro_sub,
					isMetroSub: true,
				})
			}

			// Now add in county
			let county = []
			_.forEach(this.props.payload.public.counties, (v) => {
				if (countyTracker.includes(v.id)) {
					county.push({
						value: `County` + v.id,
						label: v.name,
						group: v.id,
						county: true,
					})
				}
			})
			if (county.length > 0) {
				arr.push({
					label: "Counties",
					options: county,
					isCounty: true,
				})
			}
		}
		if (user.modules && user.modules[0] == "*") {
			arr.push({
				label: "All Properties",
				options: [{ value: "*", label: "Company Wide" }],
				isMetroSub: true,
			})
			// This is for instances where there's multiple devs, like Johnson with JDS
			if (settings.developerPropertyBuckets) {
				let trues = []
				let falses = []
				_.forEach(this.props.payload.public.properties, (v) => {
					if (v.developer && v.active == 1) trues.push(v.id)
					else if (!v.developer && v.active == 1) falses.push(v.id)
				})
				let opts = _.map(settings.developerPropertyBuckets, (v, k) => {
					if (v) return { label: k, value: trues, developer: true }
					else return { label: k, value: falses, developer: true }
				})

				arr.push({
					label: "Developer Options",
					options: opts,
				})
			}
		}
		return arr
	}

	generateRoutes = () => {
		let ret = []
		for (let v of this.props.payload.modules) {
			if (!v.component) {
				continue
			}
			ret.push(<Route path={v.path} exact component={this.state.components[v.component]} key={v.path} />)
			if (v.children) {
				for (let r of v.children) {
					ret.push(<Route path={r.path} exact component={this.state.components[r.component]} key={r.path} />)
				}
			}
		}
		return ret
	}

	viewAs = () => {
		var jwtDecode = require("jwt-decode")
		var user = localStorage.getItem("user")
		user = jwtDecode(user)
		if (user.viewAsPermission == 1) {
			return (
				<>
					<p className="top__selectTitle">View As:</p>
					<ReactSelect
						options={helpers.listViewAsUsers(
							this.props.payload.users,
							this.props.payload.public.builders,
							this.props.activeProperties
						)}
						value={this.props.viewAs}
						onChange={(a, b) => this.changeUser(b)}
						onBlur={() => {}}
						className="top__select select"
						classNamePrefix="multiSelect"
						filterOption={true}
						disableSoloSelect
					/>
				</>
			)
		}
		return ""
	}

	displayMonitors = () => {
		return _.map(this.state.monitor, (v, k) => {
			const user = _.find(this.props.payload.users, { id: v.user })
			const property = _.find(this.props.payload.public.properties, { id: v.property })

			return (
				<li key={k}>
					<span>
						<strong className="text-sm">&gt;</strong>{" "}
						<span className="text-sm">
							{user && (
								<span className="text-green-400">
									{user.first} {user.last} -{" "}
								</span>
							)}
							{property && <span className="text-purple-400">{property.name} - </span>}
							{v.excerpt}{" "}
							<span className="text-gray-500 ml-2 text-xs">
								{moment.unix(v.addedDate).format("M/D/YY h:mm a")}
							</span>
						</span>
					</span>
				</li>
			)
		})
	}

	outputMonitor = () => {
		try {
			let user = currentUser()
			if (user?.modules?.[0] !== "*") return ""
			return (
				<div
					className={classNames(
						`bg-[#212121] w-full px-2 py-2 relative text-white h-[8vh] lg:h-[6vh] 2xl:h-[5vh] flex items-end justify-start cursor-pointer transition-all`,
						{
							"!top-0 !h-[40vh]": this.state.monitorOpen,
						}
					)}
					onClick={() => {
						this.setState({ monitorOpen: !this.state.monitorOpen })
					}}>
					<div className="monitor h-full w-full code overflow-y-auto">
						<ul
							className={classNames(`w-full`, {
								"absolute bottom-0 left-0": !this.state.monitorOpen,
							})}>
							{this.displayMonitors()}
						</ul>
					</div>
				</div>
			)
		} catch (e) {
			console.log(e)
			return ""
		}
	}

	historicalNotes = () => {
		try {
			let notes = []
			_.forEach(this.props.payload.historicalNotes, (v) => {
				let inter = _.intersection(v.properties, this.props.activeProperties)
				if (
					v.start_date >= this.props.currentDates.startStamp &&
					v.end_date <= this.props.currentDates.endStamp &&
					inter.length > 0
				) {
					notes.push(v)
				}
			})
			if (notes?.length) {
				return (
					<div className="bg-blue text-white text-xs pl-2 py-1">
						<p className="font-bold pb-1">Historical Notes</p>
						<div className="flex items-center">
							{_.map(notes, (v, k) => {
								return (
									<div className="flex items-center border border-white mr-2" key={`note-${k}`}>
										<div className="bg-white text-blue px-2">
											{moment.unix(v.start_date).format("M/D/YY")} -{" "}
											{moment.unix(v.end_date).format("M/D/YY")}
										</div>
										<div className="px-2">{v.note}</div>
									</div>
								)
							})}
						</div>
					</div>
				)
			}
		} catch (e) {
			console.log(e)
		}
		return ""
	}

	render() {
		if (this.state.invalid) {
			return <Redirect to={"/login"} />
		} else if (this.state.viewAs) {
			// Go through and check what type of user this is
			if (this.state.viewAsID === 14) {
				return <Redirect to={`/arc`} />
			} else if (this.state.viewAsID === 2) {
				return <Redirect to={`/salesManager/dashboard`} />
			} else if (this.state.viewAsID === 15) {
				return <Redirect to={`/superintendent/lot-inventory`} />
			}
			return <Redirect to={"/entry/dashboard"} />
		} else if (this.state.isDriveMode) {
			return <DriveMode onExit={this.exitDriveMode} />
		} else {
			return (
				<>
					<DriveModeButton onClick={this.toggleDriveMode} isDriveMode={this.state.isDriveMode} />
					{this.outputMonitor()}
					{settings?.ai?.enabled && user?.super ? <ChatInterface /> : ""}
					<div className="globalCont c">
						<div className="top">
							<div className="top__logo">
								<Link to="/">
									<img
										src={settings.logo}
										alt="Pipsy"
										className={classNames(`top__logoImg`, {
											shake: this.state.shake,
										})}
									/>
								</Link>
								<div onClick={() => this.setState({ navOpen: !this.state.navOpen })}>
									<MobileMenuButton />
								</div>
							</div>
							<div className="top__global">
								<div className="top__propertyPicker flex-1">
									<p className="top__selectTitle">Active Properties:</p>
									<PropertySelect
										isMulti
										options={this.listProperties()}
										value={this.props.activeProperties}
										onChange={(f, controlHeld) => this.changeProperties(f, controlHeld)}
										onBlur={() => {}}
										className="top__select"
										classNamePrefix="multiSelect"
										clearable
									/>
								</div>
								<div className="top__finder lg:flex items-end flex-1 justify-center hidden">
									<Finder />
								</div>
								<div className="top__globalRight flex-1">
									<div className="top__viewAs">{this.viewAs()}</div>
									<ul className="top__globalList">
										{/*<li><i className="far fa-bell"></i></li>*/}
										<li>
											<Switched
												onChange={() => {
													let newState = !this.state.dark
													if (newState) {
														// dark mode
														document.querySelector("html").classList.add("dark")
														document.querySelector("body").classList.add("dark")
													} else {
														document.querySelector("html").classList.remove("dark")
														document.querySelector("body").classList.remove("dark")
													}
													localStorage.setItem("darkMode", newState)
													this.setState({ dark: newState })
												}}
												checked={this.state.dark}
												onColor={"#111"}
												checkedIcon={
													<svg
														xmlns="http://www.w3.org/2000/svg"
														viewBox="0 0 384 512"
														className="w-[14px] ml-[10px] translate-y-[5px]">
														<path
															d="M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
															fill="#fff"
														/>
													</svg>
												}
												uncheckedIcon={
													<svg
														xmlns="http://www.w3.org/2000/svg"
														viewBox="0 0 512 512"
														className="w-5 mt-1 ml-1">
														<path
															d="M256 0c-13.3 0-24 10.7-24 24V88c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm0 400c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V424c0-13.3-10.7-24-24-24zM488 280c13.3 0 24-10.7 24-24s-10.7-24-24-24H424c-13.3 0-24 10.7-24 24s10.7 24 24 24h64zM112 256c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H88c13.3 0 24-10.7 24-24zM437 108.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-45.3 45.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L437 108.9zM154.2 357.8c-9.4-9.4-24.6-9.4-33.9 0L75 403.1c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l45.3-45.3c9.4-9.4 9.4-24.6 0-33.9zM403.1 437c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-45.3-45.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L403.1 437zM154.2 154.2c9.4-9.4 9.4-24.6 0-33.9L108.9 75c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l45.3 45.3c9.4 9.4 24.6 9.4 33.9 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
															fill="#fff"
														/>
													</svg>
												}
											/>
										</li>
										<li>
											<Link to="/account" title="Change Password">
												<i className="far fa-user-cog" />
											</Link>
										</li>
										<li>
											<Link to="/logout" title="Logout">
												<i className="far fa-power-off" />
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div className="body">
							<div className="body__nav">
								<ul
									className={classNames("body__navList", {
										active: this.state.navOpen,
									})}>
									<li className="body__mobileClose" onClick={this.toggleMobileMenu}>
										<i className="far fa-times-octagon" />
									</li>
									<li className="body__mobileLogo">
										<img src="/img/logo.svg" alt="Pipsy" />
									</li>
									{this.renderNav()}
								</ul>
							</div>
							<div className="body__stageCont">
								<Sentry.ErrorBoundary
									fallback={
										<p className="px-8 py-8">
											An error has occurred and our development team has been notified. Please
											check back later. For now, please <a href="/">click here.</a>
										</p>
									}>
									<div className="body__stage" id="stage">
										{this.historicalNotes()}
										<Switch>
											{/* Global */}
											<Route path="/" exact component={this.state.components["Dashboard"]} />
											<Route path="/account" exact component={Account} />
											<Route path="/thanks" exact component={ThankYou} />
											{/* Dynamic */}
											{this.generateRoutes()}
											<Route path="/admin/lot-management/:id" exact component={LotManagement} />
										</Switch>
										<TablePrinter />
									</div>
								</Sentry.ErrorBoundary>
							</div>
						</div>
						<p className="body__issues" data-html2canvas-ignore="true">
							<a href="https://www.pipsy.io">Pipsy</a> {__APPVERSION__} | Master Planned Community Engine
							| Made in Texas
						</p>
						<Overlay />
						<LoadingOverlay />
					</div>
				</>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		activeProperties: state.activeProperties,
		payload: state.payload,
		viewAs: state.viewAs,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
			setActiveProperties,
			setViewAs,
		},
		dispatch
	)
}

export default compose(connect(mapStateToProps, matchDispatchToProps))(App)
